// material-ui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type FooterProps = {
  centered?: boolean;
  offsetLeft?: { xs: number; lg?: number };
};

export default function Footer({ centered = false, offsetLeft = { xs: 0 } }: FooterProps) {
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        position: 'fixed',
        left: offsetLeft,
        right: 0,
        bottom: 0,
        zIndex: theme.zIndex.appBar - 1,
        borderTop: '1px solid',
        borderTopColor: 'divider',
        bgcolor: 'background.paper',
        px: { xs: 2, sm: 3 },
        py: 1.25
      })}
    >
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: centered ? 'center' : 'flex-start' }}>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            letterSpacing: 0,
            textAlign: centered ? 'center' : 'left',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%'
          }}
        >
          BUSINESS HOTEL SERVICE INTERNATIONAL&nbsp;&nbsp; HAARLEMMERWEG 331A 1051LH&nbsp;&nbsp; AMSTERDAM&nbsp;&nbsp; T: 020
          616 27 27&nbsp;&nbsp; E:{' '}
          <Link href="mailto:info@bhs.nl" className="footer-text" color="text.secondary" underline="hover">
            INFO@BHS.NL
          </Link>
        </Typography>
      </Stack>
    </Box>
  );
}
